<template>
  <div class="row">
    <header-servico
      :familia="familia.id"
      :loading="loading"
      tipo="Benefícios"
    />
    <load v-if="loading" message="Carregando benefícios da Família" />
    <div v-else class="col-md-12">
      <!--Tabela-->
      <div class="row">
        <sidebar-servicos active="beneficios" />
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
                  v-if="!novo_beneficio"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button
                            class="btn btn-primary"
                            @click="novo_beneficio = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                        </div>

                        <div>
                          <b-button-group>
                            <b-button
                              :class="viewFilterReport === true ? 'active' : ''"
                              variant="outline-dark"
                              @click="viewFilters"
                            >
                              <i class="fas fa-filter"></i>
                              {{ $t("Filtros") }}
                            </b-button>
                            <b-button variant="outline-dark" @click="print()">
                              <i class="fas fa-print"></i>
                            </b-button>
                            <b-button
                              v-b-tooltip.hover
                              :title="$t('Exportar')"
                              variant="outline-dark"
                              @click="exportar()"
                            >
                              <i class="fas fa-file-excel"></i>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div v-if="viewFilterReport" class="col-12">
                      <form ref="formFiltros" @submit.prevent="getBeneficios">
                        <div class="row">
                          <form-select
                            v-model="filtroPessoas"
                            :itens="pessoas"
                            :multiple="true"
                            grid="12"
                            label="Usuário(s)"
                          />
                          <form-calendar
                            v-model="data_inicio"
                            grid="6"
                            label="Data Inicial"
                          />

                          <form-calendar
                            v-model="data_fim"
                            :required="verificaDataInicial"
                            grid="6"
                            label="Data Final"
                          />

                          <form-select
                            v-model="filtroStatusParecer"
                            :itens="$root.arrays.status_parecer"
                            grid="6"
                            label="Status do Parecer"
                          />

                          <form-select
                            v-model="filtroStatusConcessao"
                            :itens="$root.arrays.status_liberacao"
                            grid="6"
                            label="Status da Concessão"
                          />

                          <div class="col-md-12">
                            <label><b>Pesquisar</b></label>
                            <div class="input-group">
                              <b-input
                                v-model="search"
                                aria-describedby="input-search"
                                class="form-control search-input"
                                placeholder="Protocolo, Tipos, Técnico e Unidade"
                                type="text"
                              />
                              <div
                                class="input-group-append"
                                role="button"
                                @click.prevent="getBeneficios"
                              >
                                <span id="input-search" class="input-group-text"
                                  ><i class="fas fa-search search-icon"
                                /></span>
                              </div>
                            </div>
                            <p class="small text-muted">
                              No campo acima você pode pesquisar por: Protocolo,
                              Tipos, Técnico e Unidade
                            </p>
                          </div>
                        </div>
                        <div
                          class="row pt-2 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default btn-sm"
                              @click.prevent="
                                limparFiltros();
                                viewFilterReport = false;
                              "
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              class="btn btn-secondary btn-sm"
                              type="button"
                              @click.prevent="limparFiltros()"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>
                            <button
                              class="btn btn-success btn-submit btn-sm"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Filtrar") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <load v-if="loadingBeneficios" mode="table" />
                    <div v-else class="col-12">
                      <span>
                        <a
                          v-if="!showName"
                          @click.prevent="mostrarNome"
                          href="#"
                          ><i class="fas fa-eye"></i> Mostrar Nome de
                          Registro</a
                        >
                        <a v-else @click.prevent="ocultarNome" href="#"
                          ><i class="fas fa-eye-slash"></i> Ocultar Nome de
                          Registro</a
                        >
                      </span>
                      <print-content>
                        <template v-slot:datas> </template>

                        <b-table
                          :fields="[
                            {
                              key: 'protocolo',
                              label: $t('Detalhes'),
                            },
                            {
                              key: 'status_nome',
                              label: $t('Status'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right no-print',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="beneficiosList"
                          :responsive="true"
                          hover
                          outlined
                          show-empty
                          small
                          stacked="xs"
                          striped
                          table-class="mb-3"
                        >
                          <template v-slot:cell(protocolo)="data">
                            <i
                              v-if="data.item.privado == 1"
                              class="mdi mdi-lock mdi-18px text-danger"
                            ></i>
                            Usuário:
                            <strong
                              v-if="!data.item.usuario.nome_social"
                              v-html="
                                $options.filters.highlight(
                                  data.item.usuario.nome_completo,
                                  search
                                )
                              "
                            ></strong>
                            <span v-else>
                              <strong
                                >{{ data.item.usuario.nome_social }} ( N.R.: )
                              </strong>
                              <strong
                                v-if="showName"
                                v-html="
                                  $options.filters.highlight(
                                    data.item.usuario.nome_completo,
                                    search
                                  )
                                "
                              ></strong>
                            </span>
                            <br />
                            Protocolo:
                            <strong
                              v-html="
                                $options.filters.highlight(
                                  data.item.protocolo,
                                  search
                                )
                              "
                            ></strong>
                            <br />
                            Benefício:
                            <strong
                              v-if="data.item.beneficio.nome"
                              v-html="
                                $options.filters.highlight(
                                  data.item.beneficio.nome,
                                  search
                                )
                              "
                            ></strong>
                            <br />
                            <span v-if="data.item.quantidade > 0">
                              Quantidade entregue:
                              <b> {{ data.item.quantidade_entregue }} de {{ data.item.quantidade }}</b
                              ><br />
                            </span>
                            <span v-if="data.item.Periodicidade">
                              Periodicidade:
                              <b>{{
                                getValue(
                                  data.item.periodicidade,
                                  $root.arrays.periodicidade
                                )
                              }}</b
                              ><br />
                            </span>
                            <span v-if="data.item.data_previsao_entrega">
                              Data de previsão de entrega:
                              <b>
                                {{ formatarDataPrevisaoEntrega(data.item.data_previsao_entrega) }}
                              </b>
                              <br />
                            </span>

                            Cadastrado :
                            <b>{{ data.item.cadastrado }}</b><br />
                            Técnico autor:
                            <strong
                              v-if="data.item.autor"
                              v-html="
                                $options.filters.highlight(
                                  data.item.autor,
                                  search
                                )
                              "
                            ></strong>
                            <br />
                            Unidade:

                            <strong
                              v-if="data.item.responsavel"
                              v-html="
                                $options.filters.highlight(
                                  data.item.responsavel.tecnico.unidade.nome,
                                  search
                                )
                              "
                            ></strong>
                            <span
                              v-if="data.item.atendimento"
                              class="d-block small"
                            >
                              Atendimento criado automaticamente
                              <router-link
                                :to="`/dashboard/atendimentos/show/${data.item.atendimento.id}`"
                                >#{{
                                  data.item.atendimento.protocolo
                                }}</router-link
                              >
                            </span>
                          </template>
                          <template v-slot:cell(status_nome)="data">
                            <small class="text-muted text-xs"
                              >Status da Concessão:
                            </small>
                            <span
                              class="small"
                              v-html="data.item.status_nome"
                            ></span>
                            <br />
                            <small class="text-muted text-xs"
                              >Status do Parecer:</small
                            >
                            <span
                              v-if="
                                data.item.status_nome ==
                                  'AGUARDANDO VISITA TÉCNICA' ||
                                data.item.status_parecer == 4
                              "
                              class="small text-muted"
                              >VISITA TÉCNICA REALIZADA</span
                            >
                            <span
                              v-else
                              v-html="data.item.status_parecer_nome"
                            ></span>
                            <small
                              v-if="data.item.atualizado"
                              class="text-muted"
                              ><br />{{ data.item.atualizado }}</small
                            >
                          </template>
                          <template v-slot:cell()="data">
                            <button
                              v-b-popover.hover.top="'Editar Benefício'"
                              class="px-2 mb-0 btn btn-sm btn-success my-1 d-flex justify-content-start"
                              @click="redirectBeneficio(data.item.id)"
                            >
                              <i class="mdi mdi-square-edit-outline" />
                            </button>
                            <button
                              v-b-popover.hover.top="'Entregar Benefício'"
                              class="px-2 mb-0 btn btn-sm btn-info my-1 d-flex justify-content-start"
                              @click="
                                $bvModal.show('entrega-beneficio');
                                beneficio = data.item;
                                status_anterior = data.item.status_liberacao;
                              "
                              v-if="data.item.quantidade_entregue < data.item.quantidade"
                            >
                              <i class="mdi mdi-check" />
                            </button>
                            <button
                              v-b-popover.hover.top="
                                'Informar que o Benefício não foi entregue'
                              "
                              class="px-2 mb-0 btn btn-sm btn-danger my-1 d-flex justify-content-start"
                              @click="
                                $bvModal.show('tentativa-entrega');
                                beneficio = data.item;
                                status_anterior = data.item.status_liberacao;
                              "
                              v-if="data.item.quantidade_entregue < data.item.quantidade"
                            >
                              <i class="mdi mdi-close" />
                            </button>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>
                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              v-model="perPage"
                              class="form-control"
                              style="width: 70px"
                              v-on:change="getBeneficios"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              v-model="page"
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <NovoBeneficio
                  v-else
                  :familia="familia"
                  @voltar="novo_beneficio = false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalEntrega
      :beneficio="beneficio"
      :statusAnterior="status_anterior"
      @submit="getBeneficios"
      :familiares="familiares"
    />
    <ModalTentativaEntrega
      :beneficio="beneficio"
      :statusAnterior="status_anterior"
      @submit="getBeneficios"
    />
  </div>
</template>
<script>
import NovoBeneficio from "./Add";
import ModalEntrega from "./ModalEntregaGeral";
import ModalTentativaEntrega from "./ModalTentativaEntrega";

export default {
  components: { NovoBeneficio, ModalEntrega, ModalTentativaEntrega },
  name: "beneficios",
  metaInfo() {
    return {
      title: this.$i18n.t("Gestão de Benefício"),
    };
  },
  data() {
    return {
      showName: false,
      familia: {},
      beneficio: "",
      familiares: [],
      status_anterior: 0,
      novo_beneficio: false,
      TipobeneficiosList: [],
      beneficiosList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingBeneficios: true,
      is_entregue: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      filtroStatusConcessao: null,
      filtroStatusParecer: null,
      filtroDatas: [],
      filtroPessoas: [],
      filtroTipos: [],
      listTipos: [],
    };
  },
  computed: {
    pessoas() {
      const pessoas = this.familia.familiares ?? [];

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value:
          elem.posicao_familiar == 1
            ? "<b>RF - </b> " +
              elem.nome_completo +
              " <b>" +
              elem.idade +
              " ano(s)</b>"
            : elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>",
      }));
      return map;
    },
  },
  mounted() {
    this.$route.query.familia_id = this.$route.params.id;
    if (typeof this.$route.query.item === "object") {
      this.familia = this.$route.query.item;
    } else {
      this.getFamilia();
    }
    this.getBeneficios();
  },
  methods: {
    formatarDataPrevisaoEntrega(data) {
      if (!data) return "";

      const [ano, mes, dia] = data.split("-");

      return `${dia}/${mes}/${ano}`;
    },
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    getValue(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    getBeneficios() {
      this.loadingBeneficios = true;

      if (this.beneficiosList && this.beneficiosList.length > 0) {
        this.listTipos = this.beneficiosList;
      }

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/familia/beneficios", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatusParecer: this.filtroStatusParecer,
            filtroStatusConcessao: this.filtroStatusConcessao,
            filtroDatas: this.filtroDatas,
            filtroPessoas: this.filtroPessoas,
            filtroTipos: this.filtroTipos,
          },
        })
        .then((response) => {
          this.beneficiosList = response.data.data;
          this.pagination = response.data.pagination;
          this.familiares = response.data.familiares.map((item) => {
            return {
              id: item,
              value: item,
            };
          });
          
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getBeneficios();
          } else {
            this.loadingBeneficios = false;
          }
        })
        .catch(() => {
          this.loadingBeneficios = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/familia/beneficios", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatusParecer: this.filtroStatusParecer,
            filtroStatusConcessao: this.filtroStatusConcessao,
            filtroDatas: this.filtroDatas,
            filtroPessoas: this.filtroPessoas,
            filtroTipos: this.filtroTipos,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getBeneficios();
      }
    },
    redirectBeneficio(id) {
      this.$router.push({
        path: `/dashboard/familia/beneficio/edit/${id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.params.id)
        .then((response) => {
          this.familia = response.data.data;
          this.$route.query.familia_id = this.familia.id;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
    limparFiltros() {
      this.search = "";
      this.filtroPessoas = [];
      this.filtroStatusParecer = null;
      this.filtroStatusConcessao = null;
      this.filtroDatas = [];
      this.filtroTipos = [];
      this.data_inicio = "";
      this.data_fim = "";
      this.getBeneficios();
    },
  },
};
</script>
